import {useLayoutEffect} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';

import {RootState} from '../../../../../index';
import {getGameXpState} from '../../../../../selectors/fortnite-game/gameXpSelector';
import {GameXpState} from '../../../../../reducers/fortnite-game/gameXp.reducer';
import gameXpActions from '../../../../../actions/fortnite-game/gameXp.actions';
import {UseTabDataParams} from '../types';

export interface UseGameXpState extends GameXpState {
    total: number;
    reload: () => void;
}

const useGameXpData = ({islandCode, startDate, endDate}: UseTabDataParams): UseGameXpState => {
    const dispatch = useDispatch();

    const {data, loading, error}: GameXpState = useSelector<RootState, GameXpState>(
        getGameXpState,
        shallowEqual
    );

    const {activations = []} = data;
    const total = activations.reduce((acc, {activations}) => acc + activations, 0);

    const queryParams = {
        islandCode,
        fromTs: startDate.valueOf(),
        toTs: endDate.valueOf()
    };

    const fetchData = () => {
        dispatch(gameXpActions.getGameXp(queryParams));
    };

    useLayoutEffect(() => {
        if (islandCode) {
            fetchData();
        }
    }, [islandCode, startDate, endDate]);

    return {
        data,
        total,
        loading,
        error,
        reload: fetchData
    };
};

export default useGameXpData;
